import React, { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import baseUrl from '../../components/baseUrl';
import Nav from '../../components/Nav/Nav';
import DashboardNav from '../../components/Nav/DashboardNav';
import blogImage1 from '../assets/Blog_image1.png';
import blogImage2 from '../assets/Blog_image2.jpg';
import blogImage3 from '../assets/Blog_image3.png';
import authorIcon from '../assets/author.svg'
import dateIcon from '../assets/date.svg'
import timeIcon from '../assets/time.svg'
import Footer from '../../components/Footer/Footer';
import { LOCAL_STORAGE_TOKEN_KEY } from '../../utils/constants';

const BlogDetail = () => {
    const { slug } = useParams();  // Get the slug from the URL
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [user, setUser] = useState(null)

    const blogImages = [blogImage3,blogImage2,blogImage1];


    const blogTags = [
        "Event Planning",
        "Event in Ghana",
        "Vendors in Ghana",
        "Vendors Options"
    ];

    // Decode the data 
    function decodeData(data) {
        return atob(data); // Base64 encoding
    }

    useEffect(() => {
        const storeToken = window.localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
        // Decode the JWT token
        const decodedToken = storeToken ? decodeData(storeToken) : null;
        const userInfo = decodedToken ? jwtDecode(decodedToken) : null;
        if (userInfo) {
            setUser(userInfo?.user)
        }
    }, [setUser])

    useEffect(() => {
        const fetchBlog = async () => {
            try {
                const response = await axios.get(`${baseUrl}/blogposts`);
                const blogs = response.data.data.map((blog, index) => ({
                    ...blog,
                    image: blogImages[index % blogImages.length]
                }));
               

                // Find blog with matching slug
                const foundBlog = blogs.find(blog =>
                    blog.title.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '') === slug
                );

                if (foundBlog) {
                    setBlog(foundBlog);
                } else {
                    setError("Blog not found.");
                }
            } catch (err) {
                setError("Error fetching blog.");
            } finally {
                setLoading(false);
            }
        };

        fetchBlog();
    }, [slug]);

    // Function to check if the content contains HTML tags
    const hasHTMLTags = (content) => {
        const div = document.createElement("div");
        div.innerHTML = content;
        return div.innerHTML !== content; // If different, it contains HTML
    };

    if (loading) return <p className="text-center text-gray-600 mt-6">Loading...</p>;
    if (error) return <p className="text-center text-red-500 mt-6">{error}</p>;

    return (
        <div>
            {user ?
                <DashboardNav /> : <Nav />}
            <div className='blog-container pt-[116px] sm:pt-[146px] lg:pt-[160px] px-6 md:px-8 xl:px-[102px] pb-[88px]'>

                <img src={blog.image || "https://via.placeholder.com/600"} alt={blog.title} className="w-full h-56  md:h-[40vh] lg:h-[50vh] xl:h-[62vh] object-cover rounded-[20px]"  />

                {/* <img src={Submit_pic || "https://via.placeholder.com/400"} alt={blog.title} className="w-full h-56  md:h-[32vh] lg:h-[40vh] xl:h-[58vh] object-cover rounded-[20px]" /> */}
                {/* <img src={blogImages[index+1 % blogImages.length]} alt={blog.title} className="w-full h-56 xl:h-72 object-cover rounded-[20px]" /> */}

                <h2 className="text-sm lg:text-[30px] lg:leading-[40.5px] xl:text-[35px] xl:leading-[47.2px] font-black  mt-[9px] md:mt-[29px]">{blog.title}</h2>

                <div className='mt-4 md:mt-[18px] flex flex-wrap  gap-[10px]'>

                    {blogTags.map((tag, index) => (
                        <div className='text-ravash text-xs xl:text-base font-medium border border-ravgray h-[28px] p-3 items-center flex  rounded-[20px]  ' key={index}>
                            {tag}
                        </div>
                    ))}

                </div>

                <div className='flex gap-3 lg:gap-6 mt-[38px] md:mt-[18px] lg:mt-[30px]'>
                    <p className="flex items-center gap-1">
                        <img src={authorIcon} alt="Author Icon" className="lg:size-4" />
                        <span className="text-xs xl:text-base font-medium text-ravash">
                            {/* {blog.author || "crownie"} */}
                            {blog.title?.trim() === "Top Event Trends Taking Over Ghana in 2025" ? "velma nartey" : (blog.author || "crownie eme")}

                        </span>
                    </p>
                    <p className="flex items-center gap-1">
                        <img src={dateIcon} alt="Date Icon" className="lg:size-5" />
                        <span className="text-xs xl:text-base font-medium text-ravash">
                            {new Date(blog.createdAt).toDateString()}
                        </span>
                    </p>
                    <p className="flex items-center gap-1">
                        <img src={timeIcon} alt="Time Icon" className="lg:size-5" />
                        <span className="text-xs xl:text-base font-medium text-ravash">
                            3 min read
                        </span>
                    </p>


                </div>
                <div className="mt-4 text-sm font-medium">
                    {hasHTMLTags(blog.content) ? (
                        <div dangerouslySetInnerHTML={{ __html: blog.content }} />
                    ) : (
                        <p>{blog.content}</p>
                    )}
                </div>

            </div>

            <Footer />
        </div>
    );
};

export default BlogDetail;


///WITHOUT THE HTML CHECK 

// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import axios from 'axios';
// import baseUrl from '../../components/baseUrl';
// import Nav from '../../components/Nav/Nav';
// import Footer from '../../components/Footer/Footer';
// const BlogDetail = () => {
//     const { slug } = useParams();  // Get the slug from the URL
//     const [blog, setBlog] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState('');

//     useEffect(() => {
//         const fetchBlog = async () => {
//             try {
//                 const response = await axios.get(`${baseUrl}/blogposts`);
//                 const blogs = response.data.data;

//                 // Find blog with matching slug
//                 const foundBlog = blogs.find(blog =>
//                     blog.title.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '') === slug
//                 );

//                 if (foundBlog) {
//                     setBlog(foundBlog);
//                 } else {
//                     setError("Blog not found.");
//                 }
//             } catch (err) {
//                 setError("Error fetching blog.");
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchBlog();
//     }, [slug]);

//     if (loading) return <p>Loading...</p>;
//     if (error) return <p>{error}</p>;

//     return (
//         <div>
//             <Nav />
//             <div className='blog-detail-container pt-[100px] sm:pt-[165px] px-6'>
//                 <div className="max-w-4xl mx-auto">
//                     <img src={blog.image || "https://via.placeholder.com/600"} alt={blog.title} className="w-full h-64 object-cover rounded-lg" />
//                     <h1 className="text-3xl font-bold mt-6">{blog.title}</h1>
//                     <p className="text-sm text-gray-500 mt-2">By {blog.author || "Unknown"} | {new Date(blog.createdAt).toDateString()}</p>
//                     <div className="mt-4 text-lg text-gray-800">
//                         {blog.content}
//                     </div>
//                 </div>
//             </div>
//             <Footer />
//         </div>
//     );
// };

// export default BlogDetail;

